<script setup lang="ts">
import { useUsersStore } from '~/stores/users'
import type { LengthUnit } from '~/types/elementsUi'

interface FoldedHandsIconProps {
  height: LengthUnit
  width: LengthUnit
}

const props = defineProps<FoldedHandsIconProps>()

const localeStore = useLocaleStore()
const altTexts = {
  nl: 'Icoon van twee samengevouwen handen',
  en: 'Icon of two folded hands'
}
const altTag = computed(() => altTexts[localeStore.locale] ?? altTexts.nl)
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-240 -1200 1440 1440"
    :height="height"
    :width="width"
    fill="currentColor"
  >
    <title>{{ altTag }}</title>
    <path
      d="M40-120v-160q0-34 23.5-57t56.5-23h131q20 0 38 10t29 27q29 39 71.5 61t90.5 22q49 0 91.5-22t70.5-61q13-17 30.5-27t36.5-10h131q34 0 57 23t23 57v160H640v-91q-35 25-75.5 38T480-160q-43 0-84-13.5T320-212v92H40Zm120-280q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T280-520q0 50-34.5 85T160-400Zm640 0q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T920-520q0 50-34.5 85T800-400Zm-320-80q-68-62-111-104.5T302-658q-24-31-33-54.5t-9-47.5q0-50 35-85t86-35q28 0 54 12.5t45 33.5q19-21 45-33.5t54-12.5q51 0 86 35t35 85q0 24-9 47.5T658-658q-24 31-67 73.5T480-480Zm0-108q72-66 106-107.5t34-64.5q0-17-12-28.5T579-800q-12 0-23.5 7T532-772l-51 59-51-57q-14-16-25.5-23t-23.5-7q-17 0-29 11.5T340-760q0 23 34 64.5T480-588Zm0 0Z"
    />
  </svg>
</template>

<style scoped></style>
